import {HTTP} from "../http"

export default {
    namespaced: true,

    state: {
        loadingMenus: false,

        menusBackup: [],
        menus: [],

        selected: null
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        setMenus(state, menus) {
            state.menus = menus;
            state.menusBackup = JSON.parse(JSON.stringify(menus));
        },

        revert(state) {
            state.menus = state.menusBackup;
        },

        setSelected(state, selected) {
            state.selected = selected;
        },

        appendNew(state, toAppend) {
            if(toAppend.parent === undefined)
                state.menus.push(toAppend);
            else
                toAppend.parent.children.push(toAppend.child);
        }
    },

    actions: {
        remove(context, id) {
            return HTTP.delete('/admin/menus/' + id)
                .then(() => context.dispatch('menu/loadMenus', null, {root: true}))
                .then(() => context.dispatch('load'))
                .then(() => context.commit('setSelected', null))
                .catch(err => context.commit('error/set', err.response.data, { root: true }));
        },

        load(context) {
            context.commit('setLoading', true);

            return HTTP.get('/admin/menus')
                .then(response => {
                    response.data.forEach(item => {
                        walkMenuTree(item, (i) => {
                            if(i.expanded === undefined)
                                i.expanded = true;
                        });

                        walkMenuTree(item, (i) => {
                            if(item.url === null && item.pageId === null && item.children === undefined)
                                item.children = [];
                        })
                    });

                    context.commit('setMenus', response.data);

                    context.commit('setLoading', false)
                })
                .catch(err => context.commit('error/set', err.response.data, { root: true }));
        },

        save(context, item) {
            if(item !== null) {
                if(item.id === undefined) {
                    return HTTP.post('/admin/menus/new', item)
                        .then(resp => console.log(resp))
                        .then(() => context.dispatch('menu/loadMenus', null, {root: true}))
                        .then(() => context.dispatch('load'))
                        .then(() => context.commit('setSelected', null))
                        .catch(err => context.commit('error/set', err.response.data, { root: true }));
                } else {
                    return HTTP.post('/admin/menus/' + item.id, item)
                        .then(resp => console.log(resp))
                        .then(() => context.dispatch('menu/loadMenus', null, {root: true}))
                        .then(() => context.dispatch('load'))
                        .then(() => context.commit('setSelected', null))
                        .catch(err => context.commit('error/set', err.response.data, { root: true }));
                }
            }
        }
    }
};

function walkMenuTree(item, fn) {
    fn(item);

    if(item.children !== undefined) {
        item.children.forEach(child => fn(child));
    }
}


// WEBPACK FOOTER //
// ./src/store/admin-menu.js